module.exports = __webpack_public_path__ + "img/Surya.c119d9c3.jpeg";